import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';

function Navigation() {
  const { theme, themes, updateTheme } = useTheme();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user, login, logout, isAdmin } = useAuth();

  const handleThemeChange = (e) => {
    updateTheme(e.target.value);
  };

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const themeNames = {
    ocean: 'Ocean',
    sunset: 'Sunset',
    forest: 'Forest',
    midnight: 'Midnight (Dark)'
  };

  return (
    <nav className="bg-gray-800 p-4 h-16 relative z-50 flex items-center">
      <div className="max-w-7xl mx-auto flex justify-between items-center w-full">
          <div className="flex items-center">
            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden text-white focus:outline-none"
              aria-label="Toggle menu"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>

            {/* Desktop navigation */}
            <div className="hidden md:flex space-x-4">
              <NavLink to="/" className="text-white hover:text-gray-300">Home</NavLink>
              <NavLink to="/resume" className="text-white hover:text-gray-300">Resume</NavLink>
              <NavLink to="/fun-facts-display" className="text-white hover:text-gray-300">Fun Facts</NavLink>
              <NavLink to="/f1" className="text-white hover:text-gray-300">F1 Data</NavLink>
              <NavLink to="/tools" className="text-white hover:text-gray-300">Tools</NavLink>
              {isAdmin() && (
                <NavLink to="/admin" className="text-white hover:text-gray-300">Admin</NavLink>
              )}
            </div>
          </div>

          {/* Auth buttons */}
          <div className="flex items-center space-x-2">
            {user ? (
              <>
                <span className="text-white text-sm mr-2">Welcome, {user.name}</span>
                <button
                  onClick={logout}
                  className="text-white hover:text-gray-300 text-sm px-2 py-1 rounded border border-gray-600"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <button
                onClick={handleLogin}
                className="text-white hover:text-gray-300 text-sm px-2 py-1 rounded border border-gray-600"
              >
                Sign In
              </button>
            )}
          </div>

          {/* Theme selector */}
          <select
            value={theme}
            onChange={handleThemeChange}
            aria-label="Select theme"
            className="bg-gray-700 text-white px-3 py-1 rounded border border-gray-600 hover:border-gray-400 transition-colors cursor-pointer text-sm"
            id="theme-selector"
          >
            {Object.keys(themes).map((themeKey) => (
              <option key={themeKey} value={themeKey}>
                {themeNames[themeKey] || themeKey}
              </option>
            ))}
          </select>
        </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-gray-800 pb-4 z-50">
          <div className="flex flex-col space-y-2 px-6">
            <NavLink to="/" className="text-white hover:text-gray-300 py-2" onClick={() => setIsMobileMenuOpen(false)}>Home</NavLink>
            <NavLink to="/resume" className="text-white hover:text-gray-300 py-2" onClick={() => setIsMobileMenuOpen(false)}>Resume</NavLink>
            <NavLink to="/fun-facts-display" className="text-white hover:text-gray-300 py-2" onClick={() => setIsMobileMenuOpen(false)}>Fun Facts</NavLink>
            <NavLink to="/f1" className="text-white hover:text-gray-300 py-2" onClick={() => setIsMobileMenuOpen(false)}>F1 Data</NavLink>
            <NavLink to="/tools/json-compare" className="text-white hover:text-gray-300 py-2" onClick={() => setIsMobileMenuOpen(false)}>Tools</NavLink>
            {isAdmin() && (
              <NavLink to="/admin" className="text-white hover:text-gray-300 py-2" onClick={() => setIsMobileMenuOpen(false)}>Admin</NavLink>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navigation;
